import React, { useContext } from 'react'

import SavePublicTripItemButton from 'tripPlanner/components/Buttons/SavePublicTripItemButton'
import type { TripContextValue } from 'tripPlanner/contexts/TripContext'
import TripContext from 'tripPlanner/contexts/TripContext'
import type { TripItem } from 'tripPlanner/types/tripItem'

interface Props {
  item: TripItem
  className?: string
}

function SaveTripItemButton({ item, className }: Props) {
  const context = useContext<TripContextValue | null>(TripContext)

  if (!context?.isPublicTrip || !context.tripId) return null

  return (
    <SavePublicTripItemButton
      item={item}
      tripId={context.tripId}
      className={className}
    />
  )
}

export default SaveTripItemButton
